import * as React from 'react';

/**
 * Temporary placeholder view for Success page
 * Remove this when actual Success page is created
 */
export const SuccessPage = () => (
    <>
        <h2>Success!</h2>
    </>
);
